import { render } from "./DepartmentsManagementView.vue?vue&type=template&id=0adb78a0"
import script from "./DepartmentsManagementView.vue?vue&type=script&lang=js"
export * from "./DepartmentsManagementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__